import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  notFound: {
    id: 'studio.+nKwXg',
    defaultMessage:
      'This resource could not be found in the app definition. Please confirm if this resource exists.',
  },
  notManaged: {
    id: 'studio.HAw94v',
    defaultMessage:
      'This resource is not managed by Appsemble. You can find this resource at {link}',
  },
});
